import {
  Box,
  Typography,
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { ModuleGrid, type ModuleCard } from './common/ModuleGrid';
import { STACKED_ON_MOBILE } from './common/moduleCardLayouts';

const modules: ModuleCard[] = [
  {
    id: 'companies',
    title: 'Компанії',
    description: 'Облік, склади, активності та каталоги',
    icon: BusinessIcon,
    path: '/companies',
    layout: STACKED_ON_MOBILE,
  },
  {
    id: 'my-preorders',
    title: 'Мої передзамовлення',
    description: 'Замовлення, які ви зробили з каталогів',
    icon: ShoppingCartIcon,
    path: '/my-preorders',
    layout: STACKED_ON_MOBILE,
  },
];

export default function HomePage() {
  return (
    <Box sx={{ p: { xs: 1.5, sm: 3 } }}>
      <Box
        sx={{
          position: 'sticky',
          top: 64,
          zIndex: 10,
          backgroundColor: 'background.default',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          py: 1,
          mb: 1.5,
        }}
      >
        <Typography
          variant="button"
          component="h1"
          noWrap
          sx={{
            minWidth: 0,
            pr: { xs: '9px', sm: '10px' },
            color: 'primary.main',
          }}
        >
          Головна
        </Typography>
      </Box>

      <ModuleGrid modules={modules} />
    </Box>
  );
}
